import { API_URL } from "./http";

//--------------------
const login = () => `${API_URL}/login`;

const refreshToken = () => `${API_URL}/refresh-token`;

const getCarousel = () => `${API_URL}/partner-admin/details?section=corousel`;

const partnerDetails = () => `${API_URL}/partner-admin/partner-details`;

const getAgeGroups = () => `${API_URL}/partner-admin/master-data/AGE_GROUP`

const getStripeLink = (accountId) => `${API_URL}/partner-admin/generate-onboarding-link?accountId=${accountId}`;

const getStripeOnboardingStatus = (accountId) => `${API_URL}/partner-admin/account-details?accountId=${accountId}`;

const getStripeLoginLink = (accountId) =>
  `${API_URL}/partner-admin/generate-login-link?accountId=${accountId}`;


// not being used anywhere
const createOrUpdateCarousel = () =>
  `${API_URL}/partner-admin/details/corousel`;


const getAllOrganizations = (sortDirection) =>
  // `${API_URL}/partner-admin/filter`;
  `${API_URL}/partner-admin/filter`;

const getAllFilterOrganizations = (
  pageSize,
  pageNumber,
  interest,
  sectorId,
  subSectorId,
  size,
  name,
  sortDirection,
  sortBy,
  rangeAF,
  rangeGL,
  rangeMS,
  rangeTZ,
  masterDataId = null
) =>
  `${API_URL}/partner-admin/filter?${pageSize ? `pageSize=${pageSize}&` : ""}${pageNumber ? `pageNumber=${pageNumber}&` : ""
  }${sectorId ? `sectorId=${sectorId}&` : ""}${subSectorId ? `subSectorId=${subSectorId}&` : ""
  }${size ? `size=${size}&` : ""}${name ? `search=${name}&` : ""}${masterDataId ? `masterDataId=${masterDataId}&` : ""}${interest ? `assetType=${interest}&` : ""
  }${sortDirection ? `sortDirection=${sortDirection}&` : ""}${sortBy ? `sortBy=${sortBy}&` : ""
  }${rangeAF ? `range=${rangeAF}&` : ""}${rangeGL ? `range=${rangeGL}&` : ""}${rangeMS ? `range=${rangeMS}&` : ""
  }${rangeTZ ? `range=${rangeTZ}&` : ""}`;

const getReviewPendingData = (getPendingCount, reviewPending) =>
  `${API_URL}/partner-admin/filterReviews?${getPendingCount ? `getPendingCount=${getPendingCount}&` : ""
  }${reviewPending ? `reviewPending=${reviewPending}&` : ""}`;

const getAllFilterHubOrganizations = (
  pageSize,
  pageNumber,
  interest,
  sectorId,
  subSectorId,
  size,
  name,
  sortDirection,
  sortBy,
  rangeAF,
  rangeGL,
  rangeMS,
  rangeTZ,
  masterDataId = null
) =>
  `${API_URL}/partner-admin/filter?isActiveMember=false&${pageSize ? `pageSize=${pageSize}&` : ""
  }${pageNumber !== undefined && pageNumber !== null ? `pageNumber=${pageNumber}&` : ""}${sectorId ? `sectorId=${sectorId}&` : ""
  }${subSectorId ? `subSectorId=${subSectorId}&` : ""}${size ? `size=${size}&` : ""
  }${name ? `search=${name}&` : ""}${masterDataId ? `masterDataId=${masterDataId}&` : ""}${interest ? `assetType=${interest}` : ""}${sortDirection ? `sortDirection=${sortDirection}&` : ""
  }${sortBy ? `sortBy=${sortBy}&` : ""}${rangeAF ? `range=${rangeAF}&` : ""}${rangeGL ? `range=${rangeGL}&` : ""
  }${rangeMS ? `range=${rangeMS}&` : ""}${rangeTZ ? `range=${rangeTZ}&` : ""}`;

const getReviewPendingHubData = (getPendingCount, reviewPending) =>
  `${API_URL}/partner-admin/filter?isActiveMember=false&${getPendingCount ? `getPendingCount=${getPendingCount}&` : ""
  }${reviewPending ? `reviewPending=${reviewPending}&` : ""}`;

const getAllSectors = (partnerId, sectors) =>
  // `${API_URL}/sector`;
  `${API_URL}/end-user/sector/${partnerId}?masterDataEnum=${sectors}`



const getSubSectors = (sectorId, subSectors) =>
  // `${API_URL}/sector/${sectorId}`;
  `${API_URL}/end-user/get/sub-sector/${sectorId}?masterDataEnum=${subSectors}`;

const getPendingApprovals = (pageSize, pageNumber) =>
  `${API_URL}/partner-admin/pending-approvals?isActiveMember=true&${pageNumber ? `pageNumber=${pageNumber}&` : ""
  }${pageSize ? `pageSize=${pageSize}&` : ""}`;

const getPendingHubApprovals = (pageSize, pageNumber) =>
  `${API_URL}/partner-admin/pending-approvals?isActiveMember=false&${pageNumber ? `pageNumber=${pageNumber}&` : ""
  }${pageSize ? `pageSize=${pageSize}&` : ""}`;

const getMicrositePendingApprovals = (pageSize, pageNumber, isActiveMember) => {
  const memberQuery =
    isActiveMember === undefined || isActiveMember === null
      ? ""
      : `isActiveMember=${isActiveMember}&`;
  return `${API_URL}/partner-admin/pending/microsites?${memberQuery}${pageNumber !== undefined && pageNumber !== null ? `pageNumber=${pageNumber}&` : ""
    }${pageSize ? `pageSize=${pageSize}&` : ""}`;
};

const getPendingMicrositesByOrganization = (
  organizationId,
  pageNumber,
  pageSize,
  isActiveMember
) => {
  const memberQuery =
    isActiveMember === undefined || isActiveMember === null
      ? ""
      : `isActiveMember=${isActiveMember}&`;
  return `${API_URL}/partner-admin/pending/microsites?organizationId=${organizationId}&${memberQuery}${pageNumber !== undefined && pageNumber !== null ? `pageNumber=${pageNumber}&` : ""
    }${pageSize ? `pageSize=${pageSize}&` : ""}`;
};

const updateActiveMember = (orgId, toggle) => `${API_URL}/partner-admin/update-member-flag?organizationId=${orgId}&isActiveMember=${toggle}`

const deleteOrganisation = (orgId) =>
  `${API_URL}/partner-admin/organization/${orgId}`;

const getOneOrganization = (orgId) =>
  `${API_URL}/partner-admin/get-organization/${orgId}`;

const getOneOrganizationDeleted = (orgId) =>
  `${API_URL}/partner-admin/getSoftDeleted-organization/${orgId}`;

const updateOneOrganisationData = (orgId, name, type) =>
  `${API_URL}/partner-admin/update-orgdetails/${orgId}?${name ? `name=${name}&` : ""
  }${type ? `typeId=${type}` : ""}`;

const getMicrositesByOrganization = (orgId) =>
  `${API_URL}/partner-admin/organization/microsite/${orgId}`;

const deleteMicrosite = (micrositeId) =>
  `${API_URL}/partner-admin/organization/microsite/${micrositeId}`;

const updateMemberType = (orgId, toggle) =>
  `${API_URL}/partner-admin/toggle/member/${orgId}?toggle=${toggle}`

const getReviews = (orgId) => `${API_URL}/partner-admin/review/${orgId}`;

const getMicrositeReviews = (orgId) =>
  `${API_URL}/partner-admin/microsite-review/${orgId}`;
//--------------------

const forgotPassword = () => `${API_URL}/forgot-password`;

const changePassword = () => `${API_URL}/change-password`;

const getProfile = () => `${API_URL}/organization-admin/profile`;

const updateProfile = () => `${API_URL}/organization-admin/profile`;

const resetPassword = (token) =>
  `${API_URL}/reset-password/reset?token=${token}`;

const publishUnpublishMicrosite = (micrositeId) =>
  `${API_URL}/partner-admin/publish/unpublish/microsite/${micrositeId}`;

const getMicrositeDetailsTabs = (tabName, micrositeId) =>
  `${API_URL}/partner-admin/organization/${micrositeId}/details?section=${tabName}`;

const getContactUsDetails = (tabName, micrositeId) =>
  `${API_URL}/partner-admin/organization/${micrositeId}/contact-us?contactUsTypeEnum=${tabName}`;

const getMicrositeDetailsVacancyTab = (tabName, micrositeId) =>
  `${API_URL}/partner-admin/organization/${micrositeId}/vacancy?apprenticeshipType=${tabName}`;

const getPreviewExperienceofWork = (micrositeId) =>
  `${API_URL}/partner-admin/organization/microsite/${micrositeId}/experience-of-work-toggled-on`;

const getsettings = (micrositeId) =>
  `${API_URL}/partner-admin/organization/microsite/${micrositeId}/site-settings`;

const deletePartnerDetails = (tabName, id) =>
  `${API_URL}/partner-admin/details/${tabName}/${id}`;

const deleteApprovedOrg = (id) => `${API_URL}/partner-admin/organization/${id}`;

const updateMicrositeDetailsTabs = (tabName, micrositeId) =>
  `${API_URL}/partner-admin/details/corousel`;

const getPartnerLogo = (partner) =>
  `${API_URL}/end-user/supportLogo/${partner}`;

const updateLogos = (partnerName) => `${API_URL}/partner-admin/supporterLogo?subDomainName=${partnerName}`;

const restoreApprovedOrg = (id) => `${API_URL}/partner-admin/recover/${id}`;

const getAllDeletedOrganizations = (pageSize,
  pageNumber,
  interest,
  sectorId,
  subSectorId,
  size,
  searchTerm,
  sortDirection,
  sortBy,
  rangeAF,
  rangeGL,
  rangeMS,
  rangeTZ,
  masterDataId
) =>
  // `${API_URL}/partner-admin/filter-restore-org?${pageSize ? `pageSize=${pageSize}&` : ""}${pageNumber ? `pageNumber=${pageNumber}&` : ""
  // }${sectorId ? `sectorId=${sectorId}&` : ""}${subSectorId ? `subSectorId=${subSectorId}&` : ""
  // }${size ? `size=${size}&` : ""}${searchTerm ? `search=${searchTerm}&` : ""}${interest ? `assetType=${interest}&` : ""
  // }${sortDirection ? `sortDirection=${sortDirection}&` : ""}${sortBy ? `sortBy=${sortBy}&` : ""
  // }${rangeAF ? `range=${rangeAF}&` : ""}${rangeGL ? `range=${rangeGL}&` : ""}${rangeMS ? `range=${rangeMS}&` : ""
  // }${rangeTZ ? `range=${rangeTZ}&` : ""}`;

  `${API_URL}/partner-admin/filter-restore-org?${pageSize ? `pageSize=${pageSize}&` : ""}${pageNumber ? `pageNumber=${pageNumber}&` : ""
  }${sectorId ? `sectorId=${sectorId}&` : ""}${subSectorId ? `subSectorId=${subSectorId}&` : ""
  }${size ? `size=${size}&` : ""}${searchTerm ? `search=${searchTerm}&` : ""}${masterDataId ? `masterDataId=${masterDataId}&` : ""
  }${sortDirection ? `sortDirection=${sortDirection}&` : ""}${sortBy ? `sortBy=${sortBy}&` : ""
  }${rangeAF ? `range=${rangeAF}&` : ""}${rangeGL ? `range=${rangeGL}&` : ""}${rangeMS ? `range=${rangeMS}&` : ""
  }${rangeTZ ? `range=${rangeTZ}&` : ""}`;

const getProfessions = (ageGroupID) =>
  // `${API_URL}/partner-admin/end-user-tags/age-group/${ageGroupID}`;
  `${API_URL}/partner-admin/master-data/age-tag-by-age-group/${ageGroupID}`;

const help = () =>
  `${API_URL}/partner-admin/getHelpSection?userRole=PARTNER_ADMIN`;

const getFilteredHelpInfo = (userRole, searchKey) =>
  `${API_URL}/end-user/help-section/search/?userRole=${userRole}${searchKey ? `&text=${searchKey}` : ''}`


const getEngagementData = (partnerID, ageID, profID, filterType, year, month, quarter) =>
  `${API_URL}/partner-admin/totalUsersByLocationAndCategory${partnerID ? `?partnerId=${partnerID}` : ""
  }${ageID ? `&ageGroupId=${ageID}` : ""}${profID ? `&tagId=${profID}` : ""}${filterType ? `&filterType=${filterType}` : ""}${year ? `&year=${year}` : ""}${month ? `&month=${month}` : ""}${quarter ? `&quarter=${quarter}` : ""}`;

const downloadEngagementCSV = (partnerId, ageId, profId, filterType, year, month, quarter) => `${API_URL}/partner-admin/downloadCSV?partnerId=${partnerId}${ageId ? `&ageGroupId=${ageId}` : ""}${profId ? `&tagId=${profId}` : ""}${filterType ? `&filterType=${filterType}` : ""}${year ? `&year=${year}` : ""}${month ? `&month=${month}` : ""}${quarter ? `&quarter=${quarter}` : ""}`;

const feedbackForm = () => `${API_URL}/partner-admin/addFeedback`;

const getPartnerMembersOverview = (partnerId) => `${API_URL}/partner-admin/partner-overview-count/${partnerId}`;

const getOrgReviews = (id) => `${API_URL}/partner-admin/getReviews/organization/${id}`;

const deleteSupporterLogo = (itemId) =>
  `${API_URL}/partner-admin/deleteSupporterLogo/${itemId}`;

const getReviewInOrg = (reviewid) =>
  `${API_URL}/partner-admin/organization/microsite/getReviews?isActiveMember=true&organizationId=${reviewid}`;

const getDeleteReviews = (partnerId, isActiveMember) => `${API_URL}/partner-admin/getReviewRequests/partner/${partnerId}?isActiveMember=${isActiveMember}`

const approveDeleteReview = (reviewId) =>
  `${API_URL}/partner-admin/organization/microsite/deleteReview/${reviewId}`;

const denyDeleteReview = (reviewId) =>
  `${API_URL}/partner-admin/organization/sendrequest/${reviewId}`;

const getHubReviewInOrg = (reviewid) =>
  `${API_URL}/partner-admin/organization/microsite/getReviews?isActiveMember=false&organizationId=${reviewid}`;

const resetWallpaperToDefault = (partnerId) => `${API_URL}/partner-admin/defaultWallpaper/${partnerId}`;

const getAllPartnerTypes = (partnerId) =>
  // `${API_URL}/get-all-partnerType/${partnerId}?toggle=true`;
  `${API_URL}/partner-admin/org-partner-types/${partnerId}/PARTNER_TYPE`;

const getOnOrganisationType = (partnerId, type) =>
  // `${API_URL}/get-all-orgType/${partnerId}?toggle=true`;
  `${API_URL}/end-user/org-partner-types/${partnerId}/${type}`

const resendEmail = () => `${API_URL}/partner-admin/resend-email`

const getMasterDataIds = () => `${API_URL}/end-user/master-data/TABS`

const reArrangeFormData = ({ section }) => `${API_URL}/partner-admin/re-arrange-carousel?section=${section}`

const verifyOtp = (selectedOrgId, role) => `${API_URL}/verify/phone/login?role=${role}&id=${selectedOrgId}`;

const sendOtp = (id, role) => `${API_URL}/phone/login?id=${id}&role=${role}`;

const fetchOrgList = (role) => `${API_URL}/resolve-user/phone/login?role=${role}`;


const userServiceApi = {
  login,
  verifyOtp,
  sendOtp,
  refreshToken,
  fetchOrgList,
  createOrUpdateCarousel,
  forgotPassword,
  getProfile,
  updateProfile,
  changePassword,
  resetPassword,
  getAllOrganizations,
  getAllFilterOrganizations,
  getReviewPendingData,
  getAllFilterHubOrganizations,
  getReviewPendingHubData,
  getAllSectors,
  getSubSectors,
  getPendingApprovals,
  getPendingHubApprovals,
  getMicrositePendingApprovals,
  getPendingMicrositesByOrganization,
  deleteOrganisation,
  getCarousel,
  partnerDetails,
  getReviews,
  getMicrositeReviews,
  getOneOrganization,
  getOneOrganizationDeleted,
  updateOneOrganisationData,
  getMicrositesByOrganization,
  deleteMicrosite,
  updateMemberType,
  publishUnpublishMicrosite,
  getMicrositeDetailsTabs,
  getContactUsDetails,
  getMicrositeDetailsVacancyTab,
  getPreviewExperienceofWork,
  getsettings,
  deletePartnerDetails,
  deleteApprovedOrg,
  updateMicrositeDetailsTabs,
  getPartnerLogo,
  updateLogos,
  restoreApprovedOrg,
  getAllDeletedOrganizations,
  getProfessions,
  help,
  getFilteredHelpInfo,
  getEngagementData,
  downloadEngagementCSV,
  feedbackForm,
  getPartnerMembersOverview,
  getOrgReviews,
  deleteSupporterLogo,
  getReviewInOrg,
  getDeleteReviews,
  approveDeleteReview,
  denyDeleteReview,
  getHubReviewInOrg,
  resetWallpaperToDefault,
  getAllPartnerTypes,
  getOnOrganisationType,
  getAgeGroups,
  resendEmail,
  getMasterDataIds,
  reArrangeFormData,
  updateActiveMember,
  getStripeLink,
  getStripeOnboardingStatus,
  getStripeLoginLink,
};

export { userServiceApi as default };
